import Background from "../../assets/icons/banner.jpg";
import WhiteLogo from "../../assets/icons/ica-ap-logo.png";

export const images = {
  Background,
  WhiteLogo
};
